import * as React from "react";

function SvgNotificationIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10 2.2l8.3 15.7H1.7L10 2.2m0-1.8c-.4 0-.8.2-1.1.6L.1 17.7c-.4.8.2 1.7 1.1 1.7h17.6c.9 0 1.5-.9 1.1-1.7L11.1 1c-.2-.4-.7-.6-1.1-.6zm-.7 7.2v4.6c0 .4.3.7.7.7s.7-.3.7-.7V7.6c0-.4-.3-.7-.7-.7s-.7.3-.7.7m.7 6.8c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9z" /></svg>;
}

export default SvgNotificationIcon;